module.exports = __webpack_public_path__ + "static/media/logo.59d5c01f.png";